import {I18n} from '@aws-amplify/core';
import {Container, Stack} from "@mantine/core";
import {
    PlatformEditPageGrid,
    TabbedComponent,
    TabComponentTab
} from "@flexinet/ui-components";
import {InformationPropertyCard} from "./InformationPropertyCard.tsx";
import {ProductComponent} from "./ProductComponent.tsx";
import {MetadataPropertyCard} from "./MetadataPropertyCard.tsx";
import {IndexPage} from "../../provider-mappings/pages/IndexPage.tsx";
import {Product} from "../types.ts";
import {IndexPage as PricesPage} from "../../prices/pages/IndexPage.tsx";
import {IndexPage as LineItemsPage} from "../../product-line-items/pages/IndexPage.tsx";


// PlatformEditPageGrid, not a hand-rolled Grid (§2): the record summary on the left, the
// operational panels on the right, and the operator can collapse the left panel.
// The Preview tab reads `record` directly. It used to read a useState copy taken on first
// render, so after an edit it kept showing the product as it was before the save.
export const Profile = ({record}: { record: Product }) => {

    const tabs = [
        {
            title: I18n.get('Prices'),
            component: <PricesPage productId={record.id}/>,
        },
        {
            title: I18n.get('Line Items'),
            component: <LineItemsPage/>
        },
        {
            title: I18n.get('Billing Provider Mappings'),
            component: <IndexPage productId={record.id}/>
        },
        {
            title: I18n.get('Preview'),
            component: <Container><ProductComponent product={record}/></Container>
        },
    ] as TabComponentTab[];


    return (
        <PlatformEditPageGrid
            leftContent={
                <Stack gap={'xl'}>
                    <InformationPropertyCard record={record}/>
                    <MetadataPropertyCard record={record}/>
                </Stack>
            }
            rightContent={<TabbedComponent tabs={tabs}/>}
        />
    );

};
